// extracted by mini-css-extract-plugin
module.exports = {"pagination":"page_nation-module--pagination--pWLda","dots":"page_nation-module--dots--2axL7","active":"page_nation-module--active--2QZTL"};